import { render, staticRenderFns } from "./WidgetJobs.vue?vue&type=template&id=a6b660ae&scoped=true"
import script from "./WidgetJobs.vue?vue&type=script&lang=ts"
export * from "./WidgetJobs.vue?vue&type=script&lang=ts"
import style0 from "./WidgetJobs.vue?vue&type=style&index=0&id=a6b660ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b660ae",
  null
  
)

export default component.exports